import React, { useEffect } from "react";
import { connect } from "react-redux";
import CustomCarousel from "./CustomCarousel";
import { getPricesAction } from "../../redux/price/price.action";
import { getLocalStore } from "../../helper/utility";
import { getCart } from "../../redux/cart/action";
import Cart from "../floatingGroceryList/Cart";
import { serverResponse } from "../../util/fakeServer";
import useCurrentWidth from "../../hooks/widthHook";
import { BREAKPOINT } from "../../helper/constant";

//COMPONENTE FUNZIONE WRAPPER PER UTILIZZO HOOK
const CustomCarouselWrapper = (props) => {
  const width = useCurrentWidth();
  const isMobileFeed =
    (serverResponse.config.scrollVertical ||
      serverResponse.config.scrollHorizontal) &&
    width < BREAKPOINT.lg;
  const { leaflet, setPageIndex, itemId } = props;
  const localStore = getLocalStore();

  useEffect(() => {
    if (
      props.carouselIndex.labelIndex !== "Indice" &&
      serverResponse.config.dynamic_prices
    ) {
      props.getPricesAction(props.carouselIndex.labelIndex);
    }
  }, [props.carouselIndex.labelIndex, isMobileFeed]);

  useEffect(() => {
    if (localStore) {
      props.getCart();
    }
  }, []);

  return (
    <>
      <CustomCarousel
        leaflet={leaflet}
        setPageIndex={setPageIndex}
        itemId={itemId}
      />
      {props.isCartOpen && <Cart />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    carouselIndex: state.carousel,
    priceReducer: state.priceReducer,
    cartReducer: state.cartReducer,
    isCartOpen: state.cartReducer.isOpen
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPricesAction: (str) => {
      dispatch(getPricesAction(str));
    },
    getCart: () => {
      dispatch(getCart());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomCarouselWrapper);
